import React from 'react'
import { graphql } from 'gatsby'
import { IndexLayout } from '../components/index-layout/IndexLayout'
import { IndexPageQuery } from 'generated/types/gatsby'
import { Card } from '../components/card/Card'
import '../styles/pages/index.scss'

interface IndexPageProps {
  data: IndexPageQuery
}

const IndexPage = ({ data }: IndexPageProps) => {
  const topProducts = data.allMdx.edges.filter((edge) => edge.node.frontmatter.topProduct)
  const otherProducts = data.allMdx.edges.filter((edge) => !edge.node.frontmatter.topProduct)

  return (
    <IndexLayout>
      <ul className="la-top-products">
        {topProducts.map((edge) => {
          return (
            <li key={edge.node.id} className="la-top-products__item">
              <Card data={edge.node} />
            </li>
          )
        })}
      </ul>

      <div className="la-other-products-wrapper">
        <ul className="la-other-products">
          {otherProducts.map((edge) => {
            return (
              <li key={edge.node.id} className="la-other-products__item">
                <Card data={edge.node} />
              </li>
            )
          })}
        </ul>
      </div>
    </IndexLayout>
  )
}

export default IndexPage

export const query = graphql`
  query IndexPage {
    allMdx(
      filter: { fields: { sourceName: { eq: "cards" } }, frontmatter: { skipCard: { ne: true } } }
      sort: { fields: frontmatter___sort }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            links {
              title
              path
              header
              top
            }
            topProduct
            icon
          }
          body
        }
      }
    }
  }
`
